import { Component, Input, ViewContainerRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogComponent } from '../../contact-dialog/contact-dialog.component';
import { AppConfigService } from '../../../services/config/app-config.service';
import { Permissions } from '../../../enum/permission';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-visit-history',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './visit-history.component.html',
  styleUrl: './visit-history.component.scss'
})
export class VisitHistoryComponent {
  visits: any[] = [];
  visitComments: string[][] = [[]];
  visitLocation: string[] = [];
  @Input() visitHistoryDetails: any;
  errorPresent = false;
  errorMessage = '';
  emptyMessage = '';
  permissionNames:any={}
  finalPerm:any=[]
  contactClickable = false;
  scrollLeftInactive = false;
  scrollRightInactive = false;
  currentUserId = localStorage.getItem('userId');
  constructor(
    private _route: ActivatedRoute,
    public toaster: ToastrService,
    public commonUtil: CommonUtilService,
    private dialog: MatDialog,
    private _configService: AppConfigService
  ) { }
  ngOnInit() {
    this.permissionNames = this._configService.fetchPermissionv3ByViewName();
    console.log('permissions: ',this.permissionNames)
    this.checkContactPermission();
    setInterval(() => {
      this.visits = this.visitHistoryDetails.visits;
      this.visitComments = this.visits.map((visit) => visit.comments.split('/n'));
      this.visitLocation = this.visits.map((visit) => 'https://www.google.com/maps/search/?api=1&query=' + visit.latitude + ',' + visit.longitude);
      this.errorPresent = this.visitHistoryDetails.errorPresent;
      this.errorMessage = this.visitHistoryDetails.errorMessage;
      this.emptyMessage = this.visitHistoryDetails.emptyMessage;
    }, 300);
    // console.log('visits in visithistory',this.visits);
  }
  ngAfterViewInit() {
    if (this.visits.find((visit) => visit.user_id.toString() === this.currentUserId))
      document.getElementsByClassName('highlighted')[0].scrollIntoView({ inline: 'center', behavior: 'smooth' });//block: 'start',
  }
  optimizeName(name: string) {
    if (!name)
      return;
    name = name.trim();
    let parts = name.split(' '), whole = '';
    parts.forEach((part) => {
      whole = whole + part[0].toUpperCase() + part.substring(1).toLowerCase() + ' ';
    });
    return whole.trim();
  }
  checkContactPermission() {
    const params = this._route.snapshot.queryParams;
    // const allPerms = this._configService.getAllPermissions();
    // const reqSubview = allPerms.filter((item) => {
    //   return item.webRoute === 'datum' && item.country === 'INDIA' && item.state === params['state'] && item.district === params['district']
    // })[0]?.subview;
    // if (reqSubview && reqSubview.filter((subview) => subview.webRoute === 'print-&-monitor')[0].permission.includes(Permissions.CanAccessContactNo)) {
    //   this.contactClickable = true;
    // }
      this.finalPerm = [];
      const countryPerm = this.permissionNames['INDIA'];
      if (params['state']) {
        console.log('current State: ',params['state'])
        this.finalPerm = countryPerm?.allStatesPerm;
        const statePerm = countryPerm.statePerms[params['state']];
        console.log('param district: ',params['district'])
        if (params['district'] != '' && statePerm) {
          if(statePerm?.districtPerms[params['district']])
            this.finalPerm = [...this.finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[params['district']]];
          else this.finalPerm = [...this.finalPerm, ...statePerm?.allDistrictsPerm];
        }
      }
      console.log('final permissions: ',this.finalPerm)
      this.contactClickable = this.finalPerm.indexOf(Permissions.CanAccessContactNo) !== -1 ? true : false;
  }
  fetchMemberContact() {
    if (!this.contactClickable)
      return
    this.dialog.open(ContactDialogComponent, {
      data: { ...this.visitHistoryDetails.contactAccessor, from: 'PM-visited' }
    });
  }
  openMap(index: number) {
    window.open(this.visitLocation[index], 'blank');
  }
  scrollRight(hst: HTMLDivElement) {
    hst.scrollBy({ left: 900, behavior: 'smooth' });
  }
  scrollLeft(hst: HTMLDivElement) {
    hst.scrollBy({ left: -900, behavior: 'smooth' });
  }
}
